<template>
  <div
    class="booking-engine__occupancy active"
    :class="{ 'is-current': is_current }"
  >
    <div class="vb-form">
      <div
        @click="
          () => {
            $emit('scroll-into-view');
            $emit('go-to-tab', 0);
          }
        "
        class="booking-engine__occupancy__form"
      >
        <b-form-input
          ref="input-occupancy"
          id="input-occupancy"
          :placeholder="occupancy_placeholder"
          v-bind="occupancy"
          class="vb-input"
          :class="{ focus: current_tab === 0 }"
        />
        <div class="booking-engine__occupancy__icon">
          <vb-icon :name="'occupants'" :color="'666666'" :size="25" />
        </div>
      </div>
      <div class="booking-engine__floating--occupancy">
        <b-row class="d-flex align-items-end flex-wrap">
          <b-col md="8">
            <occupancy
              v-bind="occupancy"
              @updated="on_occupancy_updated"
              :max_rooms="1"
              :max_pax="4"
              :occupancy="occupancy"
            >
              <template v-slot:title>
                <p
                  class="semibold d-inline-flex align-items-center cursor-pointer"
                  v-b-popover.hover.top.html="
                    'Il Beneficiario della prestazione (Viaggiatore principale) potrai essere tu, in qualità di titolare del credito welfare, o dovrai, in alternativa, indicare un familiare. Con &quot;familiare&quot; si intende una persona così come definita dal combinato disposto dell\'Art. 433 del Codice Civile e dell\'Art. 12 del D.P.R. del 22.12.1986 n. 917 e smi (TUIR).<br><br>Ti ricordiamo che ai sensi dell\'art. 76 del DPR 445/2000, le dichiarazioni mendaci, la falsità e l\'uso di fatti falsi sono punite ai sensi del Codice penale.'
                  "
                >
                  Chi viaggerà?
                  <vb-icon
                    :name="'info'"
                    :color="sass('gray-500')"
                    :size="14"
                    class="ml-1"
                  />
                </p>
              </template>
            </occupancy>
          </b-col>
          <b-col md="4" class="d-flex align-items-end justify-content-end">
            <div class="text-center">
              <vb-button
                @click.prevent="on_ok_click"
                :vb_options="{
                  text: 'OK',
                  icon_disabled: 'lock',
                  disabled: occupancy[0].adults == 0,
                }"
              />
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Occupancy from "@components/blocks/occupancy.vue";
import { get_occupancy_placeholder } from "./logic";

export default {
  name: "booking-engine-occupancy",
  components: {
    occupancy: Occupancy,
  },
  props: {
    current_tab: {
      type: Number,
      required: true,
    },
    occupancy: {
      type: Array,
      required: true,
    },
    is_current: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    occupancy_placeholder() {
      return get_occupancy_placeholder(this.occupancy);
    },
  },
  methods: {
    sass(color) {
      // Access to SASS variables through global function
      return window.sass ? window.sass(color) : color;
    },
    on_occupancy_updated(e) {
      this.$emit("occupancy-updated", e);
    },
    on_ok_click() {
      this.$emit("go-to-tab", 1);
      this.$emit("keyd-map-init", true);
    },
  },
};
</script>

<style lang="scss" scoped>
%step {
  z-index: 10;
  height: 100%;
  &:not(.active) {
    pointer-events: none;

    input {
      background: $gray-300;
    }
  }
}

%bg-window {
  padding: 1rem;
  border-radius: 0.313rem;
  margin-top: 0.65rem;
  background-color: $white;
}

.booking-engine {
  &__occupancy {
    @extend %step;
    position: static;

    &.is-current {
      .booking-engine__floating {
        display: block;
      }
    }

    &__form {
      position: relative;
    }

    &__icon {
      position: absolute;
      top: 50%;
      right: 1rem;
      height: 24px;
      transform: translateY(-50%);
      aspect-ratio: 1 / 1;
      display: flex;
      align-items: center;
      justify-content: center;
      filter: grayscale(100%);
      svg {
        height: 24px;
        width: auto;
      }
    }
  }

  &__floating {
    display: none;
    @extend %bg-window;

    @include media-breakpoint-up(md) {
      position: absolute;
      top: auto;
      left: -$grid-gutter-width/4;
      width: auto;
      max-width: calc(70% - #{$grid-gutter-width});
    }

    @include media-breakpoint-up(xl) {
      left: 0;
      max-width: calc(50%);
    }

    &--occupancy {
      @extend .booking-engine__floating;
    }
  }
}

@include media-breakpoint-down(sm) {
  .booking-engine__occupancy {
    ::v-deep .occupancy--header {
      display: none;
    }
    ::v-deep .occupancy--room:last-child {
      margin-bottom: 1rem;
    }
  }
}

#input-occupancy {
  pointer-events: none;
}
</style>
